/**
 * API Services Index
 * Centralized export for all API services
 */

import adminService from './adminService';
import dashboardService from './dashboardService';
import serviceService from './serviceService';
import carService from './carService';
import userService from './userService';
import membershipService from './membershipService';
import couponService from './couponService';
import bannerService from './bannerService';
import sosService from './sosService';
import analyticsService from './analyticsService';
import partnerService from './partnerService';
import membershipAdminService from './membershipAdminService';
import searchService from './searchService';
import accountService from './accountService';
import serviceOrderService from './serviceOrderService';
import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

// Export all services
export {
  adminService,
  dashboardService,
  serviceService,
  carService,
  userService,
  membershipService,
  couponService,
  bannerService,
  sosService,
  analyticsService,
  partnerService,
  membershipAdminService,
  searchService,
  accountService,
  serviceOrderService,
  apiClient,
  API_ENDPOINTS,
};

// Default export for convenience
const apiServices = {
  admin: adminService,
  dashboard: dashboardService,
  service: serviceService,
  car: carService,
  user: userService,
  membership: membershipService,
  coupon: couponService,
  banner: bannerService,
  sos: sosService,
  analytics: analyticsService,
  partner: partnerService,
  membershipAdmin: membershipAdminService,
  search: searchService,
  account: accountService,
  serviceOrder: serviceOrderService,
  client: apiClient,
  endpoints: API_ENDPOINTS,
};

export default apiServices;

